<template>
  <div class="product-detail container page-content">
    <div class="row">
      <div class="col-12 col-md-5 product-detail__carousel">
        <item-image-carousel
          :plugin-path="pluginPath"
          image-url-accessor="url"
          :preview-variation-image="previewVariationImage"
        >
        </item-image-carousel>
        <div v-if="currentVariation.item.free1 || ytVideos.length > 0">
          <div class="headline__24 product-detail__yt-title">
            {{ $translate("OD3dprimaV2::Template.productVideos") }}
          </div>
          <div class="product-detail__yt-row">
            <youtube-modal
              v-if="currentVariation.item.free1"
              :video-id="currentVariation.item.free1"
            />
            <template v-for="group in ytVideos">
              <template
                v-for="property in group.properties"
                v-if="property.values && property.values.value"
              >
                <youtube-modal
                  :video-id="property.values.value.replace(/<[^>]*>?/gm, '')"
                />
                <!--                                <div class="col-6 col-md-12 col-xl-6 product-detail__yt">-->
                <!--                                    <div class="embed-responsive embed-responsive-16by9">-->
                <!--                                        <iframe class="embed-responsive-item"-->
                <!--                                                :src="'https://www.youtube-nocookie.com/embed/'+property.values.value.replace(/<[^>]*>?/gm, '')+'?controls=1'"-->
                <!--                                                frameborder="0"-->
                <!--                                                allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture"-->
                <!--                                                allowfullscreen>-->
                <!--                                        </iframe>-->
                <!--                                    </div>-->
                <!--                                </div>-->
              </template>
            </template>
          </div>
        </div>
        <div v-else class="product-detail__yt-spacer"></div>
      </div>
      <div class="col-12 col-md-7 offset-xl-1 col-xl-6 product-detail__details">
        <div
          v-if="badgeTags.length"
          ref="badgeTagRow"
          class="product-badges product-badges--inline"
          :style="badgeTagFadeStyle"
          @scroll="updateBadgeTagFade"
        >
          <component
            :is="badgeTagHref(tag) ? 'a' : 'span'"
            v-for="tag in badgeTags"
            :key="tag.id"
            :href="badgeTagHref(tag)"
            v-bind="badgeTagHref(tag) ? badgeLinkAttrs : {}"
            class="badge"
            :style="badgeTagStyle(tag)"
          >
            {{ tag.names.name }}
          </component>
        </div>
        <div class="product-detail__intro">
          <div class="product-detail__producer">
            {{
              currentVariation.filter.hasManufacturer
                ? currentVariation.item.manufacturer.externalName
                : ""
            }}
          </div>
          <div class="product-detail__ratings" @click="scrollToReviews">
            <od-feedback-average
              :show-empty-ratings="true"
              size-of-stars="small"
              :show-ratings-amount="true"
            >
            </od-feedback-average>
          </div>
        </div>
        <h1 class="product-detail__title" data-testing="item-name">
          {{ currentVariation | itemName }}
        </h1>
        <ul class="list-group product-detail__attr-info-list">
          <li class="list-group-item product-detail__attr-info-list-item">
            {{ $translate("OD3dprimaV2::Template.ItemNo") }}
            <span class="font-weight-bold">
              {{ itemId }}
            </span>
          </li>
          <li class="list-group-item product-detail__attr-info-list-item">
            {{ $translate("OD3dprimaV2::Template.variationId") }}
            <span class="font-weight-bold">
              {{ currentVariation.variation.id }}
            </span>
          </li>
          <li
            v-if="ean"
            class="list-group-item product-detail__attr-info-list-item"
          >
            {{ $translate("OD3dprimaV2::Template.variationEAN") }}
            <span class="font-weight-bold">
              {{ ean.code }}
            </span>
          </li>
          <li
            class="list-group-item product-detail__attr-info-list-item"
            v-if="currentVariation.variation.model"
          >
            {{ $translate("OD3dprimaV2::Template.variationPartNo") }}
            <span class="font-weight-bold">
              {{ currentVariation.variation.model }}
            </span>
          </li>
        </ul>
        <div v-if="currentVariation.bundleComponents">
          <div class="bundle__title">
            {{ $translate("OD3dprimaV2::Template.bundleTitle") }}
          </div>
          <ul class="bundle__list">
            <li
              class="bundle__item"
              v-for="bundleList in currentVariation.bundleComponents"
            >
              <span class="bundle__item-qty-value">
                {{ bundleList.quantity }}x
              </span>
              <a
                class="bundle__item-link"
                :href="bundleList.data | itemURL(true)"
              >
                {{ bundleList.data.texts.name1 }}
                <template
                  v-if="
                    bundleList.data.variation && bundleList.data.variation.name
                  "
                >
                  - {{ bundleList.data.variation.name }}
                </template>
              </a>
            </li>
          </ul>
        </div>
        <div class="product-detail__short-wrapper">
          <div
            class="product-detail__short-description"
            :class="showMore ? 'product-detail__short-description--show' : ''"
            v-if="currentVariation.texts.shortDescription !== ''"
          >
            <client-only>
              <p v-html="currentVariation.texts.shortDescription"></p>
            </client-only>
            <div
              class="
                d-flex
                justify-content-center
                align-items-center
                product-detail__show-more
                d-md-none
              "
              @click="showMore = !showMore"
            >
              <span>
                {{
                  showMore
                    ? $translate("OD3dprimaV2::Template.readLess")
                    : $translate("OD3dprimaV2::Template.readMore")
                }}
              </span>
            </div>
          </div>
        </div>

        <div
          class="product-detail__variation"
          v-if="attributes.length || Object.keys(units).length"
        >
          <variation-select
            @showPreviewImage="previewVariationImage = $event"
          ></variation-select>
        </div>
        <!--                <div class="product-detail__property-list"-->
        <!--                     v-if="currentVariation.filter.isSalable && variationGroupedProperties.length">-->
        <!--                    <order-property-list></order-property-list>-->
        <!--                </div>-->

        <slot name="tag-list"></slot>

        <div class="row">
          <div class="col-12 col-xl-6">
            <slot name="before-price"></slot>

            <item-price
              v-if="currentVariation.prices.default.unitPrice.value > 0"
              :show-cross-price="isRecommendedPriceActive"
            >
            </item-price>

            <graduated-prices></graduated-prices>

            <div
              class="category-discount"
              v-if="activeCategoryDiscount && showCategoryDiscountTable"
            >
              <category-discount-title
                class="category-discount__title"
                :url="activeCategoryDiscountUrl"
              ></category-discount-title>
              <table class="category-discount__table text-muted">
                <thead>
                  <tr>
                    <th>
                      {{
                        $translate(
                          "OD3dprimaV2::Template.categoryDiscountColQty"
                        )
                      }}
                    </th>
                    <th>
                      {{
                        $translate(
                          "OD3dprimaV2::Template.categoryDiscountColPercent"
                        )
                      }}
                    </th>
                  </tr>
                </thead>
                <tbody>
                  <tr
                    v-for="(tier, index) in activeCategoryDiscount.tiers"
                    :key="index"
                  >
                    <td>
                      {{
                        $translate(
                          "OD3dprimaV2::Template.categoryDiscountQty",
                          { qty: tier.minQty }
                        )
                      }}
                    </td>
                    <td>{{ tier.percent }}&nbsp;%</td>
                  </tr>
                </tbody>
              </table>
              <small class="category-discount__hint">{{
                $translate("OD3dprimaV2::Template.categoryDiscountHint")
              }}</small>
            </div>

            <slot name="after-price"></slot>
          </div>
          <div class="col-12 col-xl-6">
            <slot name="additional-content-after-vat"></slot>

            <div class="product-detail__shipping-info">
              <div class="product-detail-stock">
                <svg
                  xmlns="http://www.w3.org/2000/svg"
                  class="product-detail-stock__svg"
                  :class="{
                    'product-detail-stock__svg--no-stock':
                      currentVariation.stock.net < 1,
                  }"
                >
                  <use
                    xmlns:xlink="http://www.w3.org/1999/xlink"
                    xlink:href="#svg-shipping"
                  ></use>
                </svg>
                {{ $translate("OD3dprimaV2::Template.itemStock") }}:&nbsp;
                <strong>
                  {{ stock }}
                </strong>
              </div>
              <item-availability
                :item-id="itemId"
                class="product-detail__availability"
              ></item-availability>
            </div>
          </div>
        </div>

        <slot name="before-add-to-basket"></slot>

        <div
          v-if="currentVariation.item.itemType === 'set'"
          class="alert alert-info w-100"
        >
          {{ $translate("Ceres::Template.singleItemSetInfo") }}
        </div>
        <div v-else class="product-detail__add-to-basket row">
          <div
            class="col-12"
            v-if="activeCategoryDiscount && showCategoryDiscountProgress"
          >
            <category-discount-progress
              :rules="categoryDiscountRules"
              :category-ids="categoryDiscountCategoryIds"
              :adding="categoryDiscountOrderQuantity"
              :variation-id="currentVariation.variation.id"
              :url="activeCategoryDiscountUrl"
            >
            </category-discount-progress>
          </div>
          <add-to-basket
            class="col-12"
            v-if="currentVariation.prices.default.unitPrice.value > 0"
            :variation-id="currentVariation.variation.id"
            :is-salable="
              !!currentVariation.filter && currentVariation.filter.isSalable
            "
            :has-children="
              !!currentVariation.filter &&
              currentVariation.filter.hasActiveChildren
            "
            :interval-quantity="
              currentVariation.variation.intervalOrderQuantity || 1
            "
            :minimum-quantity="currentVariation.variation.minimumOrderQuantity"
            :maximum-quantity="
              !!currentVariation.variation.maximumOrderQuantity &&
              currentVariation.variation.maximumOrderQuantity > 0
                ? currentVariation.variation.maximumOrderQuantity
                : null
            "
            :order-properties="
              currentVariation.properties.filter(function (prop) {
                return prop.property.isOderProperty;
              })
            "
            :has-order-properties="currentVariation.hasOrderProperties"
            :has-required-order-property="
              currentVariation.hasRequiredOrderProperty
            "
            :use-large-scale="false"
            :show-quantity="true"
            :item-url="currentVariation | itemURL"
            :is-variation-selected="
              isVariationSelected && currentVariation.filter.isSalable
            "
            :has-price="currentVariation | hasItemDefaultPrice"
            :item-free-four="String(currentVariation.item.free4)"
          >
          </add-to-basket>
          <button
            class="btn btn-block btn-primary btn-appearance add-to-basket__btn"
            @click="scrollToContact()"
            v-else
          >
            {{ $translate("OD3dprimaV2::Template.contactForAQuote") }}
          </button>
        </div>
        <div class="product-detail__info-wrapper">
          <div class="product-detail__wishlist-wrapper">
            <add-to-wish-list
              v-if="currentVariation.prices.default.unitPrice.value > 0"
              :variation-id="currentVariation.variation.id"
            ></add-to-wish-list>
          </div>
          <div
            class="product-detail-question"
            v-if="currentVariation.prices.default.unitPrice.value > 0"
          >
            <span @click="scrollToContact()">
              <svg
                xmlns="http://www.w3.org/2000/svg"
                class="product-detail-question__svg"
              >
                <use
                  xmlns:xlink="http://www.w3.org/1999/xlink"
                  xlink:href="#svg-question"
                ></use>
              </svg>
              {{ $translate("OD3dprimaV2::Template.productQuestion") }}
            </span>
          </div>
          <div class="product-detail-question">
            <a
              v-if="hasManufacturerDataPart2 || hasManufacturerDataPart1"
              data-target="#eusafety"
              class="d-block"
              data-toggle="modal"
              href="#"
            >
              <svg
                xmlns="http://www.w3.org/2000/svg"
                class="product-detail-question__svg"
              >
                <use
                  xmlns:xlink="http://www.w3.org/1999/xlink"
                  xlink:href="#svg-info"
                ></use>
              </svg>
              {{ $translate("OD3dprimaV2::Template.manufacturerInfo") }}
            </a>
          </div>
        </div>

        <slot name="after-add-to-basket"></slot>
        <slot name="additional-content-after-add-to-basket"></slot>

        <!-- <div class="product-detail__bundle">
                    <item-bundle v-if="currentVariation.variation.bundleType === 'bundle'"
                        :bundle-type="currentVariation.variation.bundleType"
                        :bundle-components="currentVariation.bundleComponents"></item-bundle>
                </div> -->

        <div class="single-crossselling__wrapper">
          <slot name="crosssellingbasket"></slot>
        </div>
      </div>

      <div class="col-12 col-xl-8 order-xl-2">
        <div id="id--accordion">
          <div class="accordion__header" id="id--accordion__header-1">
            <div
              class="headline__24"
              data-toggle="collapse"
              data-target="#id--accordion__collapse-1"
              aria-controls="id--accordion__collapse-1"
            >
              {{ $translate("OD3dprimaV2::Template.singleDescription") }}
              <svg xmlns="http://www.w3.org/2000/svg">
                <use
                  xmlns:xlink="http://www.w3.org/1999/xlink"
                  xlink:href="#svg-caret"
                ></use>
              </svg>
            </div>
          </div>
          <portal
            v-if="isMounted"
            to="desktop-accordion-1"
            :disabled="isMobile"
          >
            <div
              id="id--accordion__collapse-1"
              class="collapse show"
              aria-labelledby="id--accordion__header-1"
              data-parent="#id--accordion"
              ref="articleDescription"
            >
              <client-only>
                <div class="accordion__body" v-html="_lazyContent"></div>
              </client-only>
              <a v-if="currentUrl !== canonicalUrl" :href="canonicalUrl">{{
                currentVariation | itemName
              }}</a>
            </div>
          </portal>
          <template v-else>
            <div
              id="id--accordion__collapse-1"
              class="collapse show"
              aria-labelledby="id--accordion__header-1"
              data-parent="#id--accordion"
              ref="articleDescription"
            >
              <client-only>
                <div class="accordion__body" v-html="_lazyContent"></div>
              </client-only>
              <a v-if="currentUrl !== canonicalUrl" :href="canonicalUrl">{{
                currentVariation | itemName
              }}</a>
            </div>
          </template>
          <div
            v-if="currentVariation.texts.technicalData"
            id="id--accordion__header-2"
            class="accordion__header"
          >
            <div
              class="collapsed headline__24"
              data-toggle="collapse"
              data-target="#id--accordion__collapse-2"
              aria-controls="id--accordion__collapse-2"
            >
              {{ $translate("OD3dprimaV2::Template.singleTechnicalData") }}
              <svg xmlns="http://www.w3.org/2000/svg">
                <use
                  xmlns:xlink="http://www.w3.org/1999/xlink"
                  xlink:href="#svg-caret"
                ></use>
              </svg>
            </div>
          </div>
          <portal
            v-if="isMounted"
            to="desktop-accordion-2"
            :disabled="isMobile"
          >
            <div
              v-if="currentVariation.texts.technicalData !== ''"
              id="id--accordion__collapse-2"
              class="collapse"
              aria-labelledby="id--accordion__header-2"
              data-parent="#id--accordion"
            >
              <div
                class="accordion__body"
                v-html="currentVariation.texts.technicalData"
              ></div>
            </div>
          </portal>
          <template v-else>
            <div
              v-if="currentVariation.texts.technicalData !== ''"
              id="id--accordion__collapse-2"
              class="collapse"
              aria-labelledby="id--accordion__header-2"
              data-parent="#id--accordion"
            >
              <div
                class="accordion__body"
                v-html="currentVariation.texts.technicalData"
              ></div>
            </div>
          </template>
          <div
            v-if="whatsIncluded"
            id="id--accordion__header-3"
            class="accordion__header"
          >
            <div
              class="collapsed headline__24"
              data-toggle="collapse"
              data-target="#id--accordion__collapse-3"
              aria-expanded="false"
              aria-controls="id--accordion__collapse-3"
              ref="reviewsHeader"
            >
              {{ $translate("OD3dprimaV2::Template.singleIncluded") }}
              <svg xmlns="http://www.w3.org/2000/svg">
                <use
                  xmlns:xlink="http://www.w3.org/1999/xlink"
                  xlink:href="#svg-caret"
                ></use>
              </svg>
            </div>
          </div>
          <portal
            v-if="isMounted"
            to="desktop-accordion-3"
            :disabled="isMobile"
          >
            <div
              v-if="whatsIncluded"
              id="id--accordion__collapse-3"
              class="collapse"
              aria-labelledby="id--accordion__header-3"
              data-parent="#id--accordion"
            >
              <div class="accordion__body" v-html="whatsIncluded"></div>
            </div>
          </portal>
          <template v-else>
            <div
              v-if="whatsIncluded"
              id="id--accordion__collapse-3"
              class="collapse"
              aria-labelledby="id--accordion__header-3"
              data-parent="#id--accordion"
            >
              <div class="accordion__body" v-html="whatsIncluded"></div>
            </div>
          </template>
          <div id="id--accordion__header-4" class="accordion__header">
            <div
              class="collapsed headline__24"
              data-toggle="collapse"
              data-target="#id--accordion__collapse-4"
              aria-controls="id--accordion__collapse-4"
              ref="reviewsHeader"
            >
              {{ $translate("OD3dprimaV2::Template.singleRatings") }}
              <svg xmlns="http://www.w3.org/2000/svg">
                <use
                  xmlns:xlink="http://www.w3.org/1999/xlink"
                  xlink:href="#svg-caret"
                ></use>
              </svg>
            </div>
          </div>
          <portal
            v-if="isMounted"
            to="desktop-accordion-4"
            :disabled="isMobile"
          >
            <div
              id="id--accordion__collapse-4"
              class="collapse"
              aria-labelledby="id--accordion__header-4"
              data-parent="#id--accordion"
              ref="reviewsTab"
            >
              <div class="accordion__body">
                <client-only>
                  <feedback-container
                    :options="feedbackOptions"
                  ></feedback-container>
                </client-only>
              </div>
            </div>
          </portal>
          <template v-else>
            <div
              id="id--accordion__collapse-4"
              class="collapse"
              aria-labelledby="id--accordion__header-4"
              data-parent="#id--accordion"
              ref="reviewsTab"
            >
              <div class="accordion__body">
                <client-only>
                  <feedback-container
                    :options="feedbackOptions"
                  ></feedback-container>
                </client-only>
              </div>
            </div>
          </template>
          <div
            id="id--accordion__header-5"
            class="accordion__header"
            v-if="dataSheets.length > 0"
          >
            <div
              class="collapsed headline__24"
              data-toggle="collapse"
              data-target="#id--accordion__collapse-5"
              aria-expanded="false"
              aria-controls="id--accordion__collapse-5"
            >
              {{ $translate("OD3dprimaV2::Template.singleDataSheets") }}
              <svg xmlns="http://www.w3.org/2000/svg">
                <use
                  xmlns:xlink="http://www.w3.org/1999/xlink"
                  xlink:href="#svg-caret"
                ></use>
              </svg>
            </div>
          </div>
          <div
            id="id--accordion__header-6"
            class="accordion__header accordion__header--faq"
          >
            <div
              class="collapsed headline__24"
              data-toggle="collapse"
              data-target="#id--accordion__collapse-6"
              aria-expanded="false"
              aria-controls="id--accordion__collapse-6"
            >
              FAQ
              <svg xmlns="http://www.w3.org/2000/svg">
                <use
                  xmlns:xlink="http://www.w3.org/1999/xlink"
                  xlink:href="#svg-caret"
                ></use>
              </svg>
            </div>
          </div>
          <client-only>
            <od-portal-target name="desktop-accordion-1"></od-portal-target>
            <od-portal-target name="desktop-accordion-2"></od-portal-target>
            <od-portal-target name="desktop-accordion-3"></od-portal-target>
            <od-portal-target name="desktop-accordion-4"></od-portal-target>
          </client-only>
          <div
            v-if="dataSheets.length > 0"
            id="id--accordion__collapse-5"
            class="collapse"
            aria-labelledby="id--accordion__header-5"
            data-parent="#id--accordion"
          >
            <div class="accordion__body">
              <template v-for="group in dataSheets">
                <div v-for="property in group.properties" class="mt-2">
                  <span v-if="property.cast === 'file'">
                    <a
                      :href="property.values.value | propertyFileUrl"
                      target="_blank"
                      class="d-flex align-items-center"
                    >
                      <svg
                        xmlns="http://www.w3.org/2000/svg"
                        width="18"
                        height="14"
                      >
                        <use
                          xmlns:xlink="http://www.w3.org/1999/xlink"
                          xlink:href="#svg-download"
                        ></use>
                      </svg>
                      <span class="pl-2">
                        {{ property.names | propertyName }}
                      </span>
                    </a>
                  </span>
                  <span v-else v-html="property.values.value"></span>
                </div>
              </template>
            </div>
          </div>
          <div
            id="id--accordion__collapse-6"
            class="collapse accordion__body--faq"
            aria-labelledby="id--accordion__header-6"
            data-parent="#id--accordion"
          >
            <div class="accordion__body">
              <!-- {{ $translate('OD3dprimaV2::Template.faq1CategoryId') }} -->

              <div
                v-for="i in 30"
                :key="i"
                v-if="
                  $translate(`OD3dprimaV2::Template.faq${i}Title`) &&
                  $translate(`OD3dprimaV2::Template.faq${i}Content`) &&
                  $translate(`OD3dprimaV2::Template.faq${i}Title`) !== '' &&
                  $translate(`OD3dprimaV2::Template.faq${i}Content`) !== '' &&
                  isCurrentCategory(
                    $translate(`OD3dprimaV2::Template.faq${i}CategoryId`)
                  )
                "
              >
                <div :id="`id--faq-accordion__header-${i}`" class="faq__header">
                  <div
                    class="collapsed"
                    data-toggle="collapse"
                    :data-target="`#id--faq-accordion__collapse-${i}`"
                    aria-expanded="false"
                    :aria-controls="`id--faq-accordion__collapse-${i}`"
                  >
                    {{ $translate(`OD3dprimaV2::Template.faq${i}Title`) }}
                    <svg xmlns="http://www.w3.org/2000/svg">
                      <use
                        xmlns:xlink="http://www.w3.org/1999/xlink"
                        xlink:href="#svg-caret"
                      ></use>
                    </svg>
                  </div>
                </div>
                <div
                  :id="`id--faq-accordion__collapse-${i}`"
                  class="collapse"
                  :aria-labelledby="`id--faq-accordion__header-${i}`"
                >
                  <div
                    class="faq__body"
                    v-html="$translate(`OD3dprimaV2::Template.faq${i}Content`)"
                  ></div>
                </div>
              </div>

              <div
                v-for="i in 5"
                :key="i"
                v-if="
                  $translate(`OD3dprimaV2::Template.faqGlobal${i}Title`) &&
                  $translate(`OD3dprimaV2::Template.faqGlobal${i}Content`) &&
                  $translate(`OD3dprimaV2::Template.faqGlobal${i}Title`) !==
                    '' &&
                  $translate(`OD3dprimaV2::Template.faqGlobal${i}Content`) !==
                    ''
                "
              >
                <div
                  :id="`id--faq-accordion__header-${i}-global`"
                  class="faq__header"
                >
                  <div
                    class="collapsed"
                    data-toggle="collapse"
                    :data-target="`#id--faq-accordion__collapse-${i}-global`"
                    aria-expanded="false"
                    :aria-controls="`id--faq-accordion__collapse-${i}-global`"
                  >
                    {{ $translate(`OD3dprimaV2::Template.faqGlobal${i}Title`) }}
                    <svg xmlns="http://www.w3.org/2000/svg">
                      <use
                        xmlns:xlink="http://www.w3.org/1999/xlink"
                        xlink:href="#svg-caret"
                      ></use>
                    </svg>
                  </div>
                </div>
                <div
                  :id="`id--faq-accordion__collapse-${i}-global`"
                  class="collapse"
                  :aria-labelledby="`id--faq-accordion__header-${i}-global`"
                >
                  <div
                    class="faq__body"
                    v-html="
                      $translate(`OD3dprimaV2::Template.faqGlobal${i}Content`)
                    "
                  ></div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
      <div class="col-12 col-xl-4 order-xl-1">
        <div class="product-detail__cross-selling">
          <slot name="item-list-container"></slot>
        </div>
      </div>
      <div class="col-12 offset-xl-3 col-xl-8 order-xl-3">
        <div class="product-detail__form">
          <h3
            class="headline__40 headline__border-bottom"
            ref="contactFormTitle"
          >
            {{ $translate("OD3dprimaV2::Template.productQuestion") }}?
          </h3>
          <form name="contact" id="contact-form" ref="contactForm">
            <div class="input-unit input-unit--floating input-name-field">
              <input
                disabled
                type="text"
                name="item"
                id="form_item"
                class="input-product-name"
                :value="
                  currentVariation.texts.name1 +
                  ', ' +
                  currentVariation.variation.id
                "
                required
              />
              <label for="form_item">
                {{ $translate("OD3dprimaV2::Template.formProduct") }}
              </label>
            </div>
            <div
              class="input-unit input-unit--floating input-name-field"
              data-validate="text"
            >
              <input
                type="text"
                name="name"
                id="form_name"
                required
                ref="contactName"
              />
              <label for="form_name">
                {{ $translate("OD3dprimaV2::Template.formName") }}*
              </label>
            </div>
            <div
              class="input-unit input-unit--floating input-name-field"
              data-validate="mail"
            >
              <input
                type="text"
                name="email"
                id="form_mail"
                required
                ref="contactMail"
              />
              <label for="form_mail">
                {{ $translate("OD3dprimaV2::Template.formMail") }}*
              </label>
            </div>
            <div class="input-unit input-unit--floating input-name-field">
              <input
                type="text"
                name="company"
                id="form_company"
                required
                ref="contactCompany"
              />
              <label for="form_company">
                {{ $translate("OD3dprimaV2::Template.formCompany") }}
              </label>
            </div>
            <div class="input-unit input-unit--floating input-name-field">
              <input
                type="tel"
                name="telephone"
                id="form_tel"
                required
                ref="contactTel"
              />
              <label for="form_tel">
                {{ $translate("OD3dprimaV2::Template.formPhone") }}
              </label>
            </div>
            <div
              class="input-unit input-unit--floating input-name-field"
              data-validate="text"
            >
              <textarea
                id="form_msg"
                name="form_msg"
                class="no-resize"
                maxlength="140"
                required
                :placeholder="$translate('OD3dprimaV2::Template.formMaxChars')"
                ref="contactMsg"
              >
              </textarea>
              <label for="form_msg">
                {{ $translate("OD3dprimaV2::Template.formMessage") }}*
              </label>
            </div>
            <div class="form-check" data-validate="">
              <input
                class="form-check-input"
                type="checkbox"
                id="form_privacy_check"
                name="form_privacy_check"
                required
                ref="contactPrivacy"
              />
              <label
                class="form-check-label form-check-label--error-msg"
                for="form_privacy_check"
              >
                {{ $translate("OD3dprimaV2::Template.formPleaseAccept") }}
              </label>
              <span
                class="form-check-label"
                v-html="
                  $translate('OD3dprimaV2::Template.formCheck', {
                    privacyLink: privacyLink,
                  })
                "
              >
              </span>
            </div>
            <input
              class="honey"
              type="text"
              name="username"
              autocomplete="off"
              tabindex="-1"
            />
            <button @click.prevent="sendForm" class="btn btn-primary btn-block">
              {{ $translate("OD3dprimaV2::Template.formSend") }}
            </button>
            <small class="w-100 text-center mt-2 d-block text-md-left">
              * {{ $translate("Ceres::Template.contactRequiredField") }}
            </small>
          </form>
          <div ref="refRecaptcha">
            <recaptcha v-if="recaptchaConfig !== ''"></recaptcha>
          </div>
        </div>
      </div>
    </div>
    <div id="eusafety-wrapper">
      <div class="modal fade" id="eusafety" tabindex="-1" role="dialog">
        <div class="modal-dialog">
          <div class="modal-content">
            <div class="modal-header">
              <div class="modal-title h5">
                {{ $translate("OD3dprimaV2::Template.manufacturerInfo") }}
              </div>
              <button
                aria-label="Close"
                class="close"
                data-dismiss="modal"
                type="button"
              >
                <span aria-hidden="true">×</span>
              </button>
            </div>
            <div class="modal-body">
              <div>
                <div class="manufacturer-data">
                  <div>
                    <div class="h5">
                      {{ $translate("OD3dprimaV2::Template.manufacturer") }}
                    </div>
                    <div v-if="hasManufacturerDataPart1">
                      <div v-if="manufacturerData.legalName">
                        {{ manufacturerData.legalName }}
                      </div>
                      <div
                        v-if="
                          manufacturerData.street || manufacturerData.houseNo
                        "
                      >
                        {{ manufacturerData.street }}
                        {{ manufacturerData.houseNo }}
                      </div>
                      <div
                        v-if="
                          manufacturerData.postcode || manufacturerData.town
                        "
                      >
                        {{ manufacturerData.postcode }}
                        {{ manufacturerData.town }}
                      </div>
                      <div v-if="manufacturerCountry != ''">
                        {{ manufacturerCountry }}
                      </div>
                      <div v-if="manufacturerData.email">
                        {{ manufacturerData.email }}
                      </div>
                      <div v-if="manufacturerData.phoneNumber">
                        {{ manufacturerData.phoneNumber }}
                      </div>
                    </div>
                  </div>
                  <div class="manufacturer-image" v-if="manufacturerData.logo">
                    <img
                      :src="manufacturerData.logo"
                      :alt="manufacturerData.name"
                    />
                  </div>
                </div>

                <div class="mt-4" v-if="hasManufacturerDataPart2">
                  <div class="h5">
                    {{
                      $translate("OD3dprimaV2::Template.responsibleEuPerson")
                    }}
                  </div>
                  <div v-if="manufacturerData.responsibleName">
                    {{ manufacturerData.responsibleName }}
                  </div>
                  <div
                    v-if="
                      manufacturerData.responsibleStreet ||
                      manufacturerData.responsibleHouseNo
                    "
                  >
                    {{ manufacturerData.responsibleStreet }}
                    {{ manufacturerData.responsibleHouseNo }}
                  </div>
                  <div
                    v-if="
                      manufacturerData.responsiblePostCode ||
                      manufacturerData.responsibleTown
                    "
                  >
                    {{ manufacturerData.responsiblePostCode }}
                    {{ manufacturerData.responsibleTown }}
                  </div>
                  <div v-if="responsibleManufacturerCountry != ''">
                    {{ responsibleManufacturerCountry }}
                  </div>
                  <div v-if="manufacturerData.responsibleEmail">
                    {{ manufacturerData.responsibleEmail }}
                  </div>
                  <div v-if="manufacturerData.responsiblePhoneNo">
                    {{ manufacturerData.responsiblePhoneNo }}
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import ValidationService from "ceres/app/services/ValidationService";
import NotificationService from "ceres/app/services/NotificationService";
import TranslationService from "ceres/app/services/TranslationService";
import { get } from "ceres/app/helper/get";
import { isNullOrUndefined } from "ceres/app/helper/utils";
import { serializeForm, getLabel } from "ceres/app/helper/serializeForm";
import { executeReCaptcha } from "ceres/app/helper/executeReCaptcha";
import ApiService from "ceres/app/services/ApiService";
import { whenConsented } from "~/app/helper/ODwhenConsented";
import {
  parseCategoryDiscountRules,
  categoryIdsOf,
} from "~/app/helper/categoryDiscount";
import CategoryDiscountProgress from "~/app/components/item/CategoryDiscountProgress.vue";
import CategoryDiscountTitle from "~/app/components/item/CategoryDiscountTitle.vue";
import { setVueLazyImgMixin } from "~/app/mixins/setVueLazyImg.mixin";
import { isMobileMixin } from "~/app/mixins/isMobile.mixin";
import {
  selectBadgeTags,
  parseBadgeTagIds,
  badgeTagStyle,
  badgeTagHref,
  badgeTagLinkAttrs,
  badgeTagUrlOptions,
} from "~/app/helper/badgeSlots";

const MAX_DETAIL_BADGE_TAGS = 4;

export default {
  name: "single-item",

  components: {
    CategoryDiscountProgress,
    CategoryDiscountTitle,
  },

  mixins: [setVueLazyImgMixin, isMobileMixin],

  props: {
    pleaseSelectOptionVariationId: {
      type: Number,
      default: 0,
    },
    initPleaseSelectOption: {
      type: Boolean,
      default: false,
    },
    isWishListEnabled: {
      type: Boolean,
      default: false,
    },
    itemId: {
      type: Number,
      required: true,
    },
    afterKey: Object,
    canonicalUrl: {
      type: String,
    },
    currentUrl: {
      type: String,
    },
    categoryBreadcrumbs: Array,
    categoryDiscountRules: {
      type: String,
      default: "",
    },
    categoryDiscountDisplay: {
      type: String,
      default: "both",
    },
    categoryDiscountLinks: {
      type: Array,
      default: () => [],
    },
  },

  provide() {
    return {
      itemId: this.$props.itemId,
    };
  },

  data() {
    return {
      badgeTagFadeStart: false,
      badgeTagFadeEnd: false,
      showMore: false,
      recaptchaConfig: App.config.global.googleRecaptchaApiKey,
      privacyLink: App.urls.privacyPolicy,
      pluginPath: App.pluginPath,
      lang: App.language,
      captchaConsent: false,
      dataSheetsGroup: 1,
      ytVideosGroup: 2,
      feedbackOptions: {
        allowFeedbacksOnlyIfPurchased: false,
        allowGuestFeedbacks: false,
        allowNoRatingFeedback: false,
        feedbacksPerPage: 10,
        numberOfFeedbacks: 1,
        timestampVisibility: false,
      },
      isMounted: false,
      previewVariationImage: "",
    };
  },

  jsonDataFields: ["itemData", "attributesData", "variations"],

  computed: {
    badgeTags() {
      // Der watch-Eintrag unten macht dieses computed eager: Vue wertet es in
      // initState aus, also bevor created() initVariation dispatcht. Zu dem
      // Zeitpunkt gibt es currentVariation noch nicht.
      return selectBadgeTags(
        this.currentVariation && this.currentVariation.tags,
        parseBadgeTagIds(App.badgeTagIds)
      ).slice(0, MAX_DETAIL_BADGE_TAGS);
    },

    badgeLinkAttrs() {
      return badgeTagLinkAttrs(App.badgeTagLinkTarget);
    },

    badgeTagFadeStyle() {
      return {
        "--badge-fade-start": this.badgeTagFadeStart ? "24px" : "0px",
        "--badge-fade-end": this.badgeTagFadeEnd ? "24px" : "0px",
      };
    },

    parsedCategoryDiscounts() {
      return parseCategoryDiscountRules(this.categoryDiscountRules);
    },
    categoryDiscountCategoryIds() {
      return [
        ...(this.categoryBreadcrumbs || []).map(
          (category) => category && parseInt(category.id)
        ),
        ...categoryIdsOf(this.currentVariation),
      ].filter((id) => id > 0);
    },
    activeCategoryDiscount() {
      return (
        this.parsedCategoryDiscounts.find((rule) =>
          this.categoryDiscountCategoryIds.includes(rule.catId)
        ) || null
      );
    },
    activeCategoryDiscountUrl() {
      const rule = this.activeCategoryDiscount;
      const link =
        rule &&
        this.categoryDiscountLinks.find(
          (entry) => parseInt(entry.id) === rule.catId
        );
      return (link && link.url) || "";
    },
    showCategoryDiscountTable() {
      return this.categoryDiscountDisplay !== "progress";
    },
    showCategoryDiscountProgress() {
      return this.categoryDiscountDisplay !== "table";
    },
    categoryDiscountOrderQuantity() {
      const quantity = get(
        this.$store.state,
        `items[${this.itemId}].variationOrderQuantity`
      );
      return (
        parseFloat(quantity) ||
        this.currentVariation.variation.minimumOrderQuantity ||
        1
      );
    },
    manufacturerData() {
      return this.$store.getters.currentItemVariation.item.manufacturer;
    },
    manufacturerCountry() {
      if (
        this.manufacturerData &&
        this.manufacturerData.countryObject &&
        this.manufacturerData.countryObject.name
      ) {
        return this.manufacturerData.countryObject.name;
      }
      return "";
      // if (this.manufacturerData && this.manufacturerData.countryObject && this.manufacturerData.countryObject.names) {
      //     for (let key in this.manufacturerData.countryObject.names) {
      //         if (this.manufacturerData.countryObject.names[key].language === "de") {
      //             return this.manufacturerData.countryObject.names[key].name;
      //         }
      //     }
      // }
      // return ""
    },
    hasManufacturerDataPart1() {
      if (
        this.manufacturerData.legalName ||
        this.manufacturerData.street ||
        this.manufacturerData.houseNo ||
        this.manufacturerData.postCode ||
        this.manufacturerData.responsibleTown ||
        this.manufacturerCountry !== "" ||
        (this.manufacturerData.email && this.manufacturerData.email !== "") ||
        this.manufacturerData.phoneNo
      ) {
        return true;
      }
    },
    hasManufacturerDataPart2() {
      if (
        this.manufacturerData.responsibleName ||
        this.manufacturerData.responsibleStreet ||
        this.manufacturerData.responsibleHouseNo ||
        this.manufacturerData.responsiblePostCode ||
        this.manufacturerData.responsibleTown ||
        this.responsibleManufacturerCountry !== "" ||
        (this.manufacturerData.responsibleEmail &&
          this.manufacturerData.responsibleEmail !== "")
      ) {
        return true;
      }
    },
    responsibleManufacturerCountry() {
      if (
        this.manufacturerData &&
        this.manufacturerData.responsibleCountryObject &&
        this.manufacturerData.responsibleCountryObject.name
      ) {
        return this.manufacturerData.responsibleCountryObject.name;
      }

      // if (this.manufacturerData && this.manufacturerData.responsibleCountryObject && this.manufacturerData.responsibleCountryObject.names) {
      //     for (let key in this.manufacturerData.responsibleCountryObject.names) {
      //         if (this.manufacturerData.responsibleCountryObject.names[key].language === "de") {
      //             return this.manufacturerData.responsibleCountryObject.names[key].name;
      //         }
      //     }
      // }
      return "";
    },
    isDescriptionTabActive() {
      return (
        (App.config.item.itemData.includes("item.description") ||
          App.config.item.itemData.includes("all")) &&
        !!this.currentVariation.texts.description.length
      );
    },

    isRecommendedPriceActive() {
      return (
        App.config.item.itemData.includes("item.recommendedPrice") ||
        App.config.item.itemData.includes("all")
      );
    },

    hasShippingCostsCategoryId() {
      return App.config.global.shippingCostsCategoryId > 0;
    },

    variationGroupedProperties() {
      return this.$store.getters[`${this.itemId}/variationGroupedProperties`];
    },

    variationMissingProperties() {
      return this.$store.getters[`${this.itemId}/variationMissingProperties`];
    },

    currentVariation() {
      return get(
        this.$store.state,
        `items[${this.itemId}].variation.documents[0].data`
      );
    },

    _content() {
      if (!isNullOrUndefined(this.currentVariation)) {
        return this.currentVariation.texts.description;
      }
    },

    isVariationSelected() {
      return get(
        this.$store.state,
        `items[${this.itemId}].variationSelect.isVariationSelected`
      );
    },

    attributes() {
      return get(
        this.$store.state,
        `items[${this.itemId}].variationSelect.attributes`
      );
    },

    units() {
      return get(
        this.$store.state,
        `items[${this.itemId}].variationSelect.units`
      );
    },

    ean() {
      if (
        !isNullOrUndefined(this.currentVariation.barcodes) &&
        this.currentVariation.barcodes.length > 0
      ) {
        return this.currentVariation.barcodes.find(
          (code) => code.name === "EAN_13"
        );
      }

      return undefined;
    },

    stock() {
      if (this.currentVariation.stock.net < 0) {
        return "0";
      } else if (this.currentVariation.stock.net > 50) {
        return "50+";
      } else {
        return "" + this.currentVariation.stock.net;
      }
    },

    whatsIncluded() {
      let content = "";

      if (this.lang === "en" && this.currentVariation.item.free2) {
        content = this.currentVariation.item.free2;
      }
      if (this.lang === "de" && this.currentVariation.item.free5) {
        content = this.currentVariation.item.free5;
      }
      if (this.lang === "se" && this.currentVariation.item.free6) {
        content = this.currentVariation.item.free6;
      }

      if (content === "0" || content === "") {
        return "";
      }

      return content;
    },

    dataSheets() {
      if (!isNullOrUndefined(this.currentVariation.variationProperties)) {
        return this.currentVariation.variationProperties.filter(
          (group) => group.id === this.dataSheetsGroup
        );
      }

      return [];
    },

    ytVideos() {
      if (!isNullOrUndefined(this.currentVariation.variationProperties)) {
        return this.currentVariation.variationProperties.filter(
          (group) => group.id === this.ytVideosGroup
        );
      }

      return [];
    },
  },

  watch: {
    isMobile() {
      document.dispatchEvent(new CustomEvent("update-vue-lazy-img"));
    },

    badgeTags() {
      this.$nextTick(this.updateBadgeTagFade);
    },
  },

  beforeDestroy() {
    window.removeEventListener("resize", this.updateBadgeTagFade);
  },

  created() {
    this.$store.dispatch("initVariation", this.itemData);
    this.$store.commit(
      `${this.itemId}/setPleaseSelectVariationId`,
      this.pleaseSelectOptionVariationId
    );
  },

  mounted() {
    this.isMounted = true;

    this.$nextTick(this.updateBadgeTagFade);
    window.addEventListener("resize", this.updateBadgeTagFade);

    whenConsented(
      "media.reCaptcha",
      () => (this.captchaConsent = true),
      () => (this.captchaConsent = false)
    );

    this.$nextTick(() => {
      this.$store.dispatch(
        `${this.itemId}/variationSelect/setVariationSelect`,
        {
          itemId: this.itemId,
          attributes: this.attributesData,
          variations: this.variations,
          initialVariationId: this.currentVariation.variation.id,
          isPleaseSelectOption: this.initPleaseSelectOption,
          afterKey: this.afterKey,
        }
      );

      if (this.isItemSet) {
        this.$store.dispatch("initSetComponents", this.itemData);
      }
    });

    // listen for variation change to hydrate all children lazy-hydrate components
    document.addEventListener("onVariationChanged", () =>
      this.hydrateChildren(this.$children)
    );
  },

  methods: {
    badgeTagStyle(tag) {
      return badgeTagStyle(tag);
    },

    badgeTagHref(tag) {
      return badgeTagHref(
        tag,
        App.badgeTagLinks,
        App.badgeTagLinkScope,
        "product",
        badgeTagUrlOptions()
      );
    },

    updateBadgeTagFade() {
      const row = this.$refs.badgeTagRow;

      this.badgeTagFadeStart = !!row && row.scrollLeft > 1;
      this.badgeTagFadeEnd =
        !!row && row.scrollWidth - row.clientWidth - row.scrollLeft > 1;
    },

    isCurrentCategory(categoryId) {
      if (this.categoryBreadcrumbs && this.categoryBreadcrumbs.length > 0) {
        return this.categoryBreadcrumbs.some(
          (category) => category?.id === parseInt(categoryId)
        );
      }
      return false;
    },

    getDataField(field) {
      return get(this.currentVariation, field);
    },

    sendForm() {
      if (!this.captchaConsent) {
        NotificationService.error(
          TranslationService.translate(
            "OD3dprimaV2::Template.pleaseAcceptRecaptcha"
          )
        );
      } else {
        executeReCaptcha(this.$refs.refRecaptcha)
          .then((recaptchaResponse) => {
            ValidationService.validate(this.$refs.contactForm)
              .done(() => {
                this.disableForm(this.$refs.contactForm, true);

                ApiService.post("/rest/OD3dprimaV2/customer/contact/mail", {
                  data: serializeForm(this.$refs.contactForm),
                  type: "contact",
                  recaptchaToken: recaptchaResponse,
                })
                  .done(() => {
                    this.disableForm(this.$refs.contactForm, false);
                    this.clearInputs();

                    NotificationService.success(
                      TranslationService.translate(
                        "Ceres::Template.contactSendSuccess"
                      )
                    ).closeAfter(3000);
                  })
                  .fail((response) => {
                    this.disableForm(this.$refs.contactForm, false);

                    response.error.message =
                      response.error.message ||
                      TranslationService.translate(
                        "Ceres::Template.contactSendFail"
                      );
                    NotificationService.error(response.error);
                  });
              })
              .fail((invalidFields) => {
                const fieldNames = [];

                for (const field of invalidFields) {
                  fieldNames.push(getLabel(field));
                }

                ValidationService.markInvalidFields(invalidFields, "error");
                NotificationService.error(
                  TranslationService.translate(
                    "Ceres::Template.checkoutCheckAddressFormFields",
                    { fields: fieldNames.join(", ") }
                  )
                );
              });
          })
          .catch(() => {
            NotificationService.error(
              TranslationService.translate(
                "Ceres::Template.contactReCaptchaFailed"
              )
            );
          });
      }
    },

    disableForm(form, disabled) {
      Array.prototype.slice
        .call(form.querySelectorAll("input, select, textarea, button"))
        .forEach((input) => {
          if (disabled) {
            input.classList.add("form-control--inactive");
          } else {
            input.classList.remove("form-control--inactive");
          }
        });
    },

    getFilteredDataField(field, filter) {
      if (!isNullOrUndefined(this.$options.filters[filter])) {
        return this.$options.filters[filter](this.getDataField(field));
      }

      return this.getDataField(field);
    },

    scrollToContact() {
      this.scrollTo(
        this.$refs.contactFormTitle.getBoundingClientRect().top + 150
      );
    },

    scrollToReviews() {
      let top = this.$refs.reviewsHeader.getBoundingClientRect().top;

      $(this.$refs.reviewsTab).collapse("show");

      if (this.windowWidth < 768) {
        top -= this.$refs.articleDescription.clientHeight;
      }

      this.scrollTo(top);
    },

    scrollTo(offset) {
      document.dispatchEvent(new CustomEvent("toggle-vue-lazy-img"));

      const fixedOffset = offset.toFixed();
      const onScroll = function () {
        if (window.pageYOffset.toFixed() === fixedOffset) {
          window.removeEventListener("scroll", onScroll);
          document.dispatchEvent(new CustomEvent("toggle-vue-lazy-img"));
        }
      };

      window.addEventListener("scroll", onScroll);
      onScroll();

      window.scrollTo({
        top: offset,
        behavior: "smooth",
      });
    },

    clearInputs() {
      this.$refs.contactName.value = "";
      this.$refs.contactMail.value = "";
      this.$refs.contactCompany.value = "";
      this.$refs.contactTel.value = "";
      this.$refs.contactMsg.value = "";

      this.$refs.contactPrivacy.checked = false;
    },

    // iterate recursively the children components and call their hydrate method, if it is a lazy-hydrate component
    hydrateChildren(nodes) {
      nodes.forEach((component) => {
        if (component.$options.name === "lazy-hydrate") {
          component.hydrate();
        } else if (component.$children.length) {
          this.hydrateChildren(component.$children);
        }
      });
    },
  },

  filters: {
    //sometimes prop has more then one name
    propertyName(names) {
      if (Array.isArray(names) && names.length > 0) {
        return names[names.length - 1].name;
      }
      return names.name;
    },
  },
};
</script>
